import { UserRoleEnums } from "utils/Constant";

const { SUPERVISOR, ANALYST, RECEPTIONIST, DATA_CLERK, SENIOR_MOLECULAR_BIOLOGIST,PRINICPAL_INVESTIGATOR, ADMIN } =
  UserRoleEnums;

export const espnAdminItems = [
  {
    key: "espn/sample-reception",
    id: "espn.sampleReceptionRecords",
    base: "sample-reception",
    icon: "MedicineBoxOutlined",
    roles: [SENIOR_MOLECULAR_BIOLOGIST, RECEPTIONIST],
  },
  {
    key: "espn/sample-preprocessing",
    id: "espn.samplePreprocessingRecords",
    base: "sample-preprocessing",
    icon: "ToolOutlined",
    roles: [SENIOR_MOLECULAR_BIOLOGIST, ANALYST],
  },
  {
    key: "espn/sample-extraction",
    id: "espn.sampleExtractionRecords",
    base: "sample-extraction",
    icon: "ScissorOutlined",
    roles: [SENIOR_MOLECULAR_BIOLOGIST, ANALYST],
  },
  {
    key: "espn/laboratory-results",
    id: "espn.laboratorySampleResults",
    base: "laboratory-results",
    icon: "ExperimentOutlined",
    roles: [SENIOR_MOLECULAR_BIOLOGIST, ANALYST, DATA_CLERK],
  },
  {
    key: "espn/laboratory-validation",
    id: "espn.laboratoryValidation",
    base: "laboratory-validation",
    icon: "SafetyCertificateOutlined",
    roles: [SENIOR_MOLECULAR_BIOLOGIST, PRINICPAL_INVESTIGATOR],
  },
  {
    key: "espn/laboratory-approval",
    id: "espn.laboratoryApproval",
    base: "laboratory-approval",
    icon: "CheckCircleOutlined",
    roles: [SUPERVISOR, PRINICPAL_INVESTIGATOR ],
  },
  {
    key: "espn/equipment-decontamination",
    id: "espn.equipmentDecontaminationRecords",
    base: "equipment-decontamination",
    icon: "FileDoneOutlined",
    roles: [SENIOR_MOLECULAR_BIOLOGIST, ANALYST, ADMIN],
  },
  {
    key: "espn/servicing",
    id: "espn.equipmentServiceRecords",
    base: "servicing",
    icon: "ToolOutlined",
    roles: [SENIOR_MOLECULAR_BIOLOGIST, ANALYST, ADMIN],
  },
];

export default espnAdminItems;